
import React from "react";
import ReactCountryFlag from "react-country-flag";
import { countries } from "./countries";
import { Tooltip } from '@mui/material';
export const formatCountryOptions = (countryNames) => {
  const nameMap = {};
  countries.forEach((c) => {
    nameMap[c.label.toLowerCase()] = c;
  });

  return countryNames.map((name) => {
    const found = nameMap[name.toLowerCase()];
    const code = found ? found.code : "XX";
    const label = found ? found.label : name;


    return {
      value: name,
      display: (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <ReactCountryFlag countryCode={code} svg style={{ width: "1.2em", height: "1.2em" }} />
          <span>{label}</span>
        </div>
      ),
    };
  });
};
export const renderCountryFlagsGrid = (countryNames = []) => {
  if (!countryNames?.length) return <span>-</span>;

  const flagElements = countryNames?.map((name) => {
    const found = countries?.find(c => c.label.toLowerCase() === name.toLowerCase());
    const code = found ? found.code : "XX";
    const label = found ? found.label : name;

    return (
      <Tooltip key={name} title={label} placement="top" arrow>
        <span
          style={{
            display: 'inline-block',
            marginRight: '6px',
            marginBottom: '6px',
          }}
        >
          <ReactCountryFlag
            countryCode={code}
            svg
            style={{ width: "1.3em", height: "1.3em" }}
          />
        </span>
      </Tooltip>
    );
  });

  const chunks = [];
  for (let i = 0; i < flagElements.length; i += 4) {
    chunks.push(flagElements.slice(i, i + 4));
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
      {chunks.map((chunk, index) => (
        <div key={index} style={{ display: 'flex' }}>
          {chunk}
        </div>
      ))}
    </div>
  );
};
